import React from "react";
import Modal from "react-bootstrap/Modal";
import EXCLAMATIONICON from "../../images/exclamationicon.svg";
import DRAFTICON from "../../images/drafticon.svg";
import AppStyles from "../../config/styles";
import {Div} from "../atoms/Div";
import { AddChildCloseIcon} from "../atoms/ConnectStories";

const styles = {
  modal: {
    justifyContent: "flex-end",
    margin: 0,
  },
  viewstyle: {
    backgroundColor: "white",
    borderTopRightRadius: "12px",
    borderTopLeftRadius: "12px",
  },
  viewLine: {
    alignSelf: "center",
    backgroundColor: AppStyles.colors.COLOR_GREYE6,
    marginTop: "6px",
    height: "4px",
    width: "96px",
  },
  iconstyle: {
    marginTop: "15px",
    marginLeft: "6%",
  },
  titlestyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "25px",
    color: "black",
    marginLeft: "10%",
    
  },
  desstyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "18px",
    color: "black",
    marginTop: "15px",
    marginLeft: "20px",
    marginRight: "15px",
    alignSelf: "center",
  },
  galleryviewstyle: {
    borderRadius: 8,
    backgroundColor: AppStyles.colors.COLOR_ORANGE,
    marginLeft: "35%",
    marginRight: "15px",
    marginTop: "25px",
    paddingTop: "15px",
    paddingBottom: "15px",
    textAlign: "center",
    width: "30%",
    boxShadow:"rgb(199, 83, 0) 0px 3px 0px"
  },
  gallerytextstyle: {
    color: AppStyles.colors.COLOR_WHITE,
    fontSize: "20px",
    fontFamily: "Lato-Bold",
    cursor:"pointer"
  },
  camerapressstyle: {
    padding: 10,
    textAlign: "center",
  },
  cameratextstyle: {
    fontSize: "20px",
    fontFamily: "Lato-Bold",
    color: AppStyles.colors.COLOR_ORANGE,
    textDecorationLine: "underline",
    alignSelf: "center",
    marginTop: "25px",
    marginBottom: "30px",
    cursor:"pointer"

  },
};

function DraftMessageModal(props) {
  const imageIcon = props?.isImport ? (
    <img src={DRAFTICON} style={styles.iconstyle} height={60} width={60} alt=""/>
  ) : <img src={EXCLAMATIONICON} style={styles.iconstyle} height={60} width={60} alt=""/>;

  return (
    <Modal
    show={props?.isVisible}
    style={styles.modal}
    animation={false}
  >
     <AddChildCloseIcon onClick={props?.onClose}>X</AddChildCloseIcon>
    <div style={styles.viewstyle}>
    <span style={styles.titlestyle}>{props?.title}</span>
      <Div flexdiv> 
      {imageIcon}
      <p style={styles.desstyle}>{props?.description}</p>
      </Div>
      <Div flexdiv draftSaveButton onClick={props?.onOkClick}>
        <div style={styles.galleryviewstyle}>
          <span style={styles.gallerytextstyle}>{props?.okText}</span>
        </div>
      </Div>
      <Div style={styles.camerapressstyle} onClick={props?.onCancelClick}>
        <span style={styles.cameratextstyle}>{props?.cancelText}</span>
      </Div>
    </div>
  </Modal>
  );
}

export default DraftMessageModal;
